import { CoreService } from "./core.service";

class DownloadService extends CoreService {
  downloadFile(filename: string): void {
    const a = document.createElement("a");
    a.href = `${process.env.PUBLIC_URL}/data/${filename}`;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  downloadFileWithPath(filename: string, filepath: string): void {
    const a = document.createElement("a");
    a.href = filepath;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export const downloadService = new DownloadService();
